module.exports = "<example-shell\n  exampleId=\"row-pinning\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Row pinning\"\n    [columns]=\"advancedColumns\"\n    [data]=\"orders\"\n    [pinnedTopRows]=\"topPinnedOrders\"\n    [pinnedBottomRows]=\"bottomPinnedOrders\"\n    [pagination]=\"true\"\n    [paginationPerPage]=\"5\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/row-pinning/row-pinning.component.html
// module id = ./src/app/examples/row-pinning/row-pinning.component.html
// module chunks = main